import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import TextField from 'components/text-field';
import MyModal from 'components/modals/modal';
import Textarea from 'components/textarea';

export default function CreateNewSuggestionModal({
  open,
  setOpen,
  edit,
  initialValues,
  createSuggestion,
  updateSuggestion,
  id,
  quickPanelHandleClose,
}) {
  const handleClose = () => {
    setOpen(false);
  };

  const [name, setName] = useState('');
  const [note, setNote] = useState('');
  const [error, setError] = useState({ status: false, message: '' });

  useEffect(() => {
    if (initialValues.name) setName(initialValues.name);
    else setName('New Suggestion');
    setNote(initialValues.description);
  }, [initialValues]);

  function validateAndSubmit() {
    if (name === '') {
      setError({ status: true, message: 'Suggestion name cannot be empty.' });
    }
    // else if (
    //   name === initialValues.name &&
    //   note === initialValues.description
    // ) {
    //   setError({
    //     status: true,
    //     message: 'Suggestion name cannot be the same as before.',
    //   });
    // }
    else {
      if (edit) {
        updateSuggestion(id, name, note);
      } else createSuggestion(name, note, quickPanelHandleClose);
      setName('');
      setNote('');
      handleClose();
    }
  }

  function resetError() {
    setError({ status: false, message: '' });
  }

  return (
    <MyModal open={open} setOpen={setOpen} size='large' showCloseIcon>
      <Stack
        spacing={2}
        justifyContent='center'
        alignItems='center'
        sx={{ position: 'relative' }}
      >
        <IconButton
          sx={{ position: 'absolute', top: 0, right: 0 }}
          onClick={(e) => {
            e.preventDefault();
            setName('');
            setNote('');
            handleClose();
          }}
        >
          <Close />
        </IconButton>
        <Typography variant='h1'>
          {edit ? 'Edit Suggestion' : 'Create New Suggestion'}
        </Typography>
        <TextField
          autoFocus
          onFocus={(e) => {
            e.target.select();
          }}
          label='Suggestion Name'
          placeholder='Enter suggestion name'
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            resetError();
          }}
          error={error.status}
          helperText={error.message}
          sx={{ width: '360px' }}
        />
        <Textarea
          rows={4}
          label='Note'
          value={note}
          onChange={(e) => {
            setNote(e.target.value);
          }}
          placeholder='Enter note'
          sx={{ width: '360px' }}
        />
        <Stack direction='row' spacing={2}>
          <Button
            variant='outlined'
            color='secondary'
            onClick={(e) => {
              e.preventDefault();
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            onClick={(e) => {
              e.preventDefault();
              validateAndSubmit();
            }}
          >
            {edit ? 'Save Changes' : 'Create'}
          </Button>
        </Stack>
      </Stack>
    </MyModal>
  );
}

CreateNewSuggestionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  edit: PropTypes.bool,
  initialValues: PropTypes.object,
  createSuggestion: PropTypes.func,
  updateSuggestion: PropTypes.func,
  quickPanelHandleClose: PropTypes.func,
  id: PropTypes.string,
};

CreateNewSuggestionModal.defaultProps = {
  edit: false,
  initialValues: { name: '', note: '' },
  createSuggestion: () => {},
  updateSuggestion: () => {},
  quickPanelHandleClose: () => {},
  id: '',
};
